<template>
    <CmsLink
        v-if="preHeader && preHeader.link"
        :link="preHeader.link"
        class="pre-header"
    >
        <div class="pre-header-content">
            {{ preHeader.link.text }}
        </div>

        <div class="curtain"></div>
    </CmsLink>
</template>

<script setup lang="ts">
import { useMenus } from '@/plugins/menu'

import CmsLink from '@/components/cms/CmsLink.vue'

const { preHeader } = useMenus()
</script>

<style lang="scss" scoped>
.pre-header {
    background: $blue;
    color: $white;
    min-height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 8px 0;

    .curtain {
        width: 100%;
        height: 100%;
        position: absolute;
        background: $white;
        opacity: 0;
        pointer-events: none;
    }

    .pre-header-content {
        font-family: $effra-font-stack;
        font-size: 0.685rem;
        line-height: 1.45em;
        letter-spacing: 0.1em;
        text-align: center;
        text-transform: uppercase;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;

        @include min-width(1024) {
            font-size: 12px;
        }

        &::after {
            @include min-width(768) {
                font-family: $icon-font;
                content: $icon-angle-right;
                font-weight: 700;
                display: inline-block;
                margin: 0 0 0 5px;
                font-size: 0.5rem;
            }
        }
    }
}
</style>
